module.exports = __webpack_public_path__ + "audio-6b6036daafc1.m4a";